import React, { useContext, useState } from 'react';

import { SkinImage } from '@app/dev/terminal/components/skinImage';
import { useOutsideClick } from '@common/hooks/outsideClick';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';
import Config from '@skin_config';

import './style.scss';

export const Footer = () => {
  const [{ openPopup }] = useContext(PopupContext);
  const [open, setOpen] = useState(false);
  const t = useTranslation();

  const wrapperRef = useOutsideClick(() => open && Config.footer.isToggleable
    && setOpen(false), [open, Config.footer.isToggleable]);
  const handleToggle = () => {
    if (Config.footer.isToggleable) {
      setOpen(!open);
    }
  };
  const onOpenPP = (e) => {
    if (!Config.footer.isToggleable) {
      openPopup(
        POPUPS.EMBED_POPUP,
        { links: Config.footer.gamblingRules?.privacyPolicy, className: 'F-popup-style' },
      );
      e.stopPropagation();
    }
  };
  const onOpenTC = (e) => {
    if (!Config.footer.isToggleable || Config.footer.termRules?.isOpen) {
      openPopup(
        POPUPS.EMBED_POPUP,
        { links: Config.footer.gamblingRules?.termsAndConditions, className: 'F-popup-style' },
      );
      e.stopPropagation();
    }
  };

  return (
    <div className={`footer ${open && 'opened'}`} onClick={handleToggle} ref={wrapperRef}>
      <div className="footer-main">
        <div className="upper-section">
          <div className="logo-section">
            <div className="logo custom-logo" />
            <span className="logo-text">
              {`${t(Config.footer?.texts?.logoText)}`}
            </span>
          </div>
          {Config.footer?.linksAndTitle?.length && Config.footer.linksAndTitle.map((item) => (
            <div key={item} className="rules-wrapper">
              <div key={item.title} className="title">
                {t(item.title)}
              </div>
              {item.childrens.map((subItem) => {
                const { link, disabled } = subItem;
                return (
                  <div key={subItem} className="link" onClick={() => !disabled && openPopup(POPUPS.EMBED_POPUP, { links: link })}>
                    {t(subItem.title)}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        {/* <div className="lower-section">
          <div className="icons">
            {Config.footer.imagesArray?.map((item) => <SkinImage isImg key={item} path={`${item}.png`} className="logo-images" alt="icon-images" fileType="png" />)}
          </div>
        </div> */}
      </div>
      <div className="footer-static">
        <div className="images-text-wrapper">
          <div className="logo-images">
            {Config.footer?.staticImages?.termsAndCondition && (
            <SkinImage
              isImg
              path={`${Config.footer?.staticImages?.termsAndCondition}.png`}
              fileType="png"
              className="icon-images"
              onClick={(e) => onOpenTC(e)}
            />
            )}
            {Config.footer?.staticImages?.plusAge && (
            <SkinImage
              isImg
              path={`${Config.footer?.staticImages?.plusAge}.png`}
              className="icon-images"
            />
            )}
          </div>
          <div className="texts-wrapper">
            <span className="rules-text" onClick={(e) => onOpenTC(e)}>{t(Config.footer?.termRules.text)}</span>
            <span className="rules-text" onClick={(e) => onOpenPP(e)}>{t(Config.footer?.policyRules)}</span>
          </div>
        </div>
        {Config.footer?.texts && (
          <span className="terms-text">
            {`${t(Config.footer?.texts?.termsText)}`}
          </span>
        )}
        <span className="reserved-text">
          {`${t(Config.footer.reservedText)}`}
        </span>
      </div>
    </div>
  );
};
